import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-evry',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './evry.component.html',
  styleUrl: './evry.component.scss'
})
export class EvryComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.evry;
}
